import { HeroUIProvider } from '@heroui/react';
import { ModalProvider } from '@ui/Modal';
import { ToastProvider } from '@ui/Toast';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export function UIProvider({ children }: Props) {
  return (
    <HeroUIProvider style={{ display: 'contents' }}>
      <ModalProvider>
        <ToastProvider>{children}</ToastProvider>
      </ModalProvider>
    </HeroUIProvider>
  );
}
